export const add = 'M114.06,236.12h27.88V19.41H114.06ZM19.64,113.82v27.89H236.36V113.82Z'
